import classNames from 'classnames'
import { handleNumberColumnChange } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/handleNumberColumnChange'
import React, { useMemo } from 'react'

import { IInputProps } from 'core-components/library/inputs'
import { FinancialBeautifiedValue } from 'partner360/components/financialBeautifiedValue/FinancialBeautifiedValue'

import { FinancialInput } from '../../styledComponents/financialInput/FinancialInput'
import styles from '../BalanceOfTrade.module.scss'

interface IProps {
  keyValue: string
  value: string | number | undefined
  onChange: (field: string, keyValue: string) => (value: string | number) => void
  field: string
  editableFields: string[]
}

export const RenderNumberColumn = ({
  keyValue,
  value,
  onChange,
  field,
  editableFields,
}: IProps) => {
  const inputProps: IInputProps = useMemo(() => {
    return {
      className: classNames(styles.alignColumns, styles.inputField),
      type: 'number',
      value: value,
    }
  }, [value])

  if (editableFields?.includes(keyValue)) {
    return (
      <FinancialInput
        {...inputProps}
        onChange={handleNumberColumnChange({
          field,
          keyValue,
          onChange,
        })}
      />
    )
  }

  return (
    <FinancialBeautifiedValue
      className={classNames(
        styles.textItem,
        styles.textItem_withMinHeight,
        styles.textItem__value,
        styles.textItem_fixMinWidth
      )}
      value={value}
    />
  )
}
